import { useNotificationDeactivate } from '@/entities/notification';

import { useNotificationBatchedAction } from './use-notification-batched-action';

export const useBatchedDeactivateNotification = () => {
  const [deactivateNotification] = useNotificationDeactivate();

  const { executeAction, transformQueryData } = useNotificationBatchedAction({
    apiAction: deactivateNotification,
    optimisticUpdate: () => null,
    batchSize: 5
  });

  return { deactivateNotification: executeAction, transformQueryData };
};
